/* TAHA SNEAK — panier : tiroir, ajout au panier, choix rapide de la pointure */
(function () {
  'use strict';
  var d = document;
  var html = d.documentElement;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DRAWER_ID = 'ts-cart-drawer';
  var R = { add: ROOT + 'cart/add.js', change: ROOT + 'cart/change.js', page: ROOT + 'cart' };
  var HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function qs(s, c) { return (c || d).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function esc(s) { var t = d.createElement('div'); t.textContent = s == null ? '' : String(s); return t.innerHTML; }

  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '{{amount_with_comma_separator}} DH';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, prec, thou, dec) {
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return whole + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(re), val;
    if (!m) return fmt;
    switch (m[1]) {
      case 'amount_no_decimals': val = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = num(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': val = num(cents, 0, ' ', ','); break;
      default: val = num(cents, 2, ',', '.');
    }
    var tmp = d.createElement('div');
    tmp.innerHTML = fmt.replace(re, val);
    return tmp.textContent;
  }

  /* ---------- Éléments ---------- */
  function drawerEl() { return d.getElementById('TsCart'); }
  function quickEl() { return d.getElementById('TsQuick'); }
  function pageEl() { return qs('[data-ts-cart-page]'); }
  function sectionIds() {
    var ids = [];
    if (drawerEl()) ids.push(DRAWER_ID);
    var p = pageEl();
    if (p && p.getAttribute('data-ts-cart-page')) ids.push(p.getAttribute('data-ts-cart-page'));
    return ids;
  }

  /* ---------- Mise à jour du contenu (sans toucher au bouton Commander) ---------- */
  function swapBody(container, markup) {
    if (!container || !markup) return null;
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var fresh = qs('[data-ts-cart-body]', doc);
    var cur = qs('[data-ts-cart-body]', container);
    if (!fresh || !cur) return null;
    cur.setAttribute('data-empty', fresh.getAttribute('data-empty'));
    cur.setAttribute('data-count', fresh.getAttribute('data-count'));
    qsa('[data-ts-swap]', cur).forEach(function (el) {
      var n = qs('[data-ts-swap="' + el.getAttribute('data-ts-swap') + '"]', fresh);
      if (n) el.innerHTML = n.innerHTML;
    });
    var hrefs = qsa('[data-ts-href]', fresh);
    qsa('[data-ts-href]', cur).forEach(function (el, i) {
      if (hrefs[i]) el.setAttribute('href', hrefs[i].getAttribute('href'));
    });
    return parseInt(fresh.getAttribute('data-count'), 10) || 0;
  }

  function apply(sections) {
    if (!sections) return false;
    var count = null;
    var dr = drawerEl();
    if (dr && sections[DRAWER_ID]) count = swapBody(dr, sections[DRAWER_ID]);
    var p = pageEl();
    if (p) {
      var id = p.getAttribute('data-ts-cart-page');
      if (id && sections[id]) {
        var c2 = swapBody(p, sections[id]);
        if (count === null) count = c2;
      }
    }
    if (count !== null) setCount(count);
    return count !== null;
  }

  function setCount(n) {
    qsa('.ts-cart__count').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    qsa('[data-ts-cart-count]').forEach(function (el) { el.textContent = n; });
    qsa('a.ts-cart .ts-sr').forEach(function (el) { el.textContent = 'Panier (' + n + ')'; });
  }

  function refresh(openAfter) {
    var ids = sectionIds();
    if (!ids.length) {
      if (openAfter) location.href = R.page;
      return Promise.resolve();
    }
    return fetch(location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { apply(s); if (openAfter) openCart(); })
      .catch(function () { if (openAfter) location.href = R.page; });
  }

  function post(url, data) {
    data.sections = sectionIds();
    data.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: HEADERS, credentials: 'same-origin', body: JSON.stringify(data) })
      .then(function (r) {
        return r.json().then(
          function (j) { if (!r.ok) throw j; return j; },
          function () { if (!r.ok) throw {}; return {}; }
        );
      });
  }

  function errMsg(e) {
    return (e && (e.description || e.message)) || 'Une erreur est survenue. Réessayez.';
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  /* ---------- Ajout / modification ---------- */
  function add(items, btn, beforeOpen) {
    busy(btn, true);
    return post(R.add, { items: items })
      .then(function (res) {
        if (apply(res.sections)) return res;
        return refresh(false).then(function () { return res; });
      })
      .then(function (res) {
        busy(btn, false);
        if (beforeOpen) beforeOpen();
        if (pageEl()) {
          toast('Ajouté au panier ✓');
        } else {
          openCart();
          highlight((res.items || []).map(function (it) { return it.key; }));
        }
        return true;
      })
      .catch(function (e) {
        busy(btn, false);
        toast(errMsg(e), true);
        return false;
      });
  }

  function change(key, qty, row) {
    if (row) row.classList.add('is-busy');
    return post(R.change, { id: key, quantity: qty })
      .then(function (res) { if (!apply(res.sections)) return refresh(false); })
      .catch(function (e) {
        if (row) row.classList.remove('is-busy');
        toast(errMsg(e), true);
      });
  }

  function highlight(keys) {
    var dr = drawerEl();
    if (!dr) return;
    keys.forEach(function (k) {
      var row = qs('[data-key="' + k + '"]', dr);
      if (!row) return;
      row.classList.remove('is-new');
      void row.offsetWidth;
      row.classList.add('is-new');
      setTimeout(function () { row.classList.remove('is-new'); }, 1500);
    });
  }

  /* ---------- Ouverture / fermeture ---------- */
  var lastFocus = null;
  function isOpen(el) { return !!el && !el.hidden && el.classList.contains('is-open'); }
  function syncLock() {
    var menu = qs('[data-ts-drawer]');
    var on = isOpen(drawerEl()) || isOpen(quickEl()) || (menu && !menu.hidden);
    html.classList.toggle('ts-lock', !!on);
  }
  function show(el) {
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    html.classList.add('ts-lock');
  }
  function hide(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    syncLock();
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 320);
  }
  function focusSoon(el) {
    if (!el) return;
    setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }, 80);
  }

  function openCart() {
    var dr = drawerEl();
    if (!dr) { location.href = R.page; return; }
    if (!isOpen(dr)) lastFocus = d.activeElement;
    show(dr);
    focusSoon(qs('.ts-cd__close', dr) || dr);
  }
  function closeCart() {
    var dr = drawerEl();
    if (!isOpen(dr)) return;
    hide(dr);
    if (lastFocus && lastFocus.focus && !isOpen(quickEl())) focusSoon(lastFocus);
  }

  /* ---------- Message ---------- */
  var toastTimer = null;
  function toast(msg, isErr) {
    var t = qs('[data-ts-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.toggle('is-error', !!isErr);
    t.hidden = false;
    void t.offsetWidth;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-show');
      setTimeout(function () { if (!t.classList.contains('is-show')) t.hidden = true; }, 280);
    }, 3200);
  }

  /* ---------- Formulaires produit (page produit) ---------- */
  function productForm(el) {
    if (!el) return null;
    var form = el.tagName === 'FORM' ? el : (el.form || (el.closest && el.closest('form')));
    if (!form) return null;
    var a = form.getAttribute('action') || '';
    if (a.indexOf('/cart/add') === -1) return null;
    if (form.hasAttribute('data-ts-native') || (form.closest && form.closest('[data-ts-pf]'))) return null;
    if (!form.querySelector('[name="id"]')) return null;
    return form;
  }
  function itemFromForm(form) {
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    if (!id) return null;
    var q = parseInt(fd.get('quantity'), 10);
    var item = { id: id, quantity: q > 0 ? q : 1 };
    var props = {}, has = false;
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && typeof v === 'string') { props[m[1]] = v; has = true; }
    });
    if (has) item.properties = props;
    var sp = fd.get('selling_plan');
    if (sp) item.selling_plan = sp;
    return item;
  }
  function onProductAdd(e, form, btn) {
    var item = itemFromForm(form);
    if (!item) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn && btn.classList.contains('is-loading')) return;
    add([item], btn);
  }

  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="add"], [data-add-to-cart]');
    if (!b || b.disabled) return;
    var form = productForm(b);
    if (form) onProductAdd(e, form, b);
  }, true);

  d.addEventListener('submit', function (e) {
    var form = productForm(e.target);
    if (form) onProductAdd(e, form, form.querySelector('button[name="add"], [data-add-to-cart]'));
  }, true);

  /* ---------- Clics ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var cartLink = t.closest('a.ts-cart');
    if (cartLink && drawerEl() && !pageEl()) { e.preventDefault(); openCart(); return; }

    if (t.closest('[data-ts-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var qb = t.closest('[data-ts-qty]');
    if (qb) {
      var row = qb.closest('[data-key]');
      if (row) {
        e.preventDefault();
        if (!row.classList.contains('is-busy')) change(row.getAttribute('data-key'), parseInt(qb.getAttribute('data-ts-qty'), 10) || 0, row);
      }
      return;
    }

    var co = t.closest('[name="checkout"]');
    if (co && drawerEl() && drawerEl().contains(co)) setTimeout(closeCart, 0);
  });

  /* ---------- Clavier ---------- */
  function trap(e) {
    var box = isOpen(quickEl()) ? qs('.ts-qs__panel', quickEl()) : (isOpen(drawerEl()) ? qs('.ts-cd__panel', drawerEl()) : null);
    if (!box) return;
    var f = qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea', box)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = d.activeElement;
    if (e.shiftKey && (a === first || !box.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !box.contains(a))) { e.preventDefault(); first.focus(); }
  }
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (isOpen(quickEl())) { if (window.TSCart.closeQuick) window.TSCart.closeQuick(); }
      else if (isOpen(drawerEl())) closeCart();
    } else if (e.key === 'Tab') {
      trap(e);
    }
  });

  /* ---------- Sections TS avec leur propre bouton d'ajout : ouvrir le panier après l'ajout ---------- */
  function watchFeatured() {
    if (!window.MutationObserver) return;
    qsa('[data-pf-msg], .ts-zr__msg, .ts-sp__msg').forEach(function (m) {
      if (m.getAttribute('data-ts-watch')) return;
      m.setAttribute('data-ts-watch', '1');
      new MutationObserver(function () {
        if (!m.classList.contains('is-error') && m.querySelector('a[href*="/cart"]')) refresh(true);
      }).observe(m, { childList: true, subtree: true });
    });
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(false); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', watchFeatured); else watchFeatured();
  d.addEventListener('shopify:section:load', watchFeatured);

  window.TSCart = {
    open: openCart,
    close: closeCart,
    refresh: refresh,
    add: add,
    toast: toast,
    money: money,
    busy: busy,
    show: show,
    hide: hide,
    isOpen: isOpen,
    focusSoon: focusSoon
  };
})();